import { Database } from "lucide-react";

// Migration çalıştırılmamış bölümlerde gösterilen zarif bilgilendirme kartı
export function MigrationNotice({ section }) {
  return (
    <div className="rounded-sm border border-[#B09060]/30 bg-[#FAFBF6] p-8 text-center" data-testid="migration-notice">
      <Database className="w-8 h-8 text-[#B09060] mx-auto" strokeWidth={1.25} />
      <h3 className="font-serif-display text-xl text-[#404040] mt-4">
        {section} için veritabanı kurulumu bekleniyor
      </h3>
      <p className="text-sm text-[#6B6B6B] mt-2 max-w-md mx-auto leading-relaxed">
        Bu bölüm yeni tablolar gerektiriyor. Veri kaybı yaratmayan migration
        dosyası hazır: <code className="text-xs bg-[#F2F3EB] px-1.5 py-0.5">supabase-migration-admin-panel.sql</code>.
        Onayınız sonrası Supabase SQL Editor'de çalıştırıldığında bu bölüm otomatik aktifleşir.
      </p>
    </div>
  );
}
